
export enum CustomerAccountTypeCd {
	INHERIT_FROM_PARENT = 'InheritFromParent',
	LOCAL_ACCOUNT = 'LocalAccount',
	NATIONAL_ACCOUNT = 'NationalAccount'}
